/* eslint-disable import/order */
import React from 'react';
import { calendarEntryPoint } from '@jira/spa-apps__advanced-roadmaps-plan-calendar/src/calendarEntryPoint.entrypoint.tsx';
import {
	advancedRoadmapsPlanPageInitialChecksResource,
	advancedRoadmapsReduxStoreStateResource,
} from '@jira/router-resources__advanced-roadmaps-plan/src/advancedRoadmapsPlanPageInitialChecksResource.tsx';
import { getPlansBacklogResource } from '@jira/router-resources__advanced-roadmaps-plan/src/plansBacklogResource.tsx';
import { PLAN_CALENDAR } from '@jira/platform__observability-capabilities/src/constants.tsx';
import { setCapability } from '@jira/platform__observability-capabilities/src/services/active-capability-tracker/index.tsx';
import { createChromelessEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { createLayout } from '@jira/platform__layouts-route-layout/src/GlobalComponent.tsx';
import { jiraSpaResources } from '@jira/router-resources__spa-page-container/src/jiraSpaResources.tsx';
import { arjCalendarEmbedRoute } from '@jira/router-routes__advanced-roadmaps-embed-routes/src/arjCalendarEmbedRoute.tsx';
import { CalendarSkeleton } from '@jira/platform__skeletons/src/ui/calendar/CalendarSkeleton.tsx';
import type { Route } from '@atlassian/react-resource-router';

const planCalendarEmbedRouteEntry = createChromelessEntryPoint({
	main: calendarEntryPoint,
});

export const arjCalendarEmbedRouteEntry: Route = createEntry(arjCalendarEmbedRoute, () => ({
	group: 'software',
	ufoName: 'software-advanced-roadmaps-calendar-embed',

	skeleton: () => {
		return <CalendarSkeleton />;
	},

	entryPoint() {
		setCapability(PLAN_CALENDAR);
		return planCalendarEmbedRouteEntry;
	},

	layout: createLayout({
		isChromeless: true,
	}),

	resources: [
		advancedRoadmapsPlanPageInitialChecksResource,
		...getPlansBacklogResource(),
		advancedRoadmapsReduxStoreStateResource,
		...jiraSpaResources(),
	],

	preloadOptions: {
		earlyChunks: ['advanced-roadmaps-early-entry'],
	},

	meta: {
		capability: PLAN_CALENDAR,
	},

	forPaint: [],

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
